import { render, staticRenderFns } from "./AutoTagsWrapper.vue?vue&type=template&id=614a5f6f&"
import script from "./AutoTagsWrapper.vue?vue&type=script&lang=js&"
export * from "./AutoTagsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('614a5f6f')) {
      api.createRecord('614a5f6f', component.options)
    } else {
      api.reload('614a5f6f', component.options)
    }
    module.hot.accept("./AutoTagsWrapper.vue?vue&type=template&id=614a5f6f&", function () {
      api.rerender('614a5f6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/AutoTagsWrapper.vue"
export default component.exports